module.exports = "<div id=\"homeImageSlider\">\n  <ul>\n    <li *ngFor=\"let photo of photos\">\n      <img src=\"../../../assets/img/evuSlider/{{ photo.imageUrl }}\" alt=\"\">\n    </li>\n  </ul>\n</div>"


//////////////////
// WEBPACK FOOTER
// /Users/emrevolkanucar/Desktop/Angular/etigumus/src/app/home/evuslider/evuslider.component.html
// module id = ../../../../../src/app/home/evuslider/evuslider.component.html
// module chunks = main